export const notificationActive = (state) => state.active
export const notificationTitle = (state) => state.title
export const notificationMessage = (state) => state.message
export const notificationAutoHide = (state) => state.autoHide
export const notificationType = (state) => state.type
